type ScrollBoundary = {
  isAtTop: boolean;
  isAtBottom: boolean;
};

export const isScrollAtBoundary = (scrollTop: number, clientHeight: number, scrollHeight: number): ScrollBoundary => ({
  isAtTop: scrollTop === 0,
  isAtBottom: scrollTop + clientHeight === scrollHeight,
});

export const shouldPreventScroll = (isAtTop: boolean, isAtBottom: boolean, delta: number): boolean =>
  (isAtTop && delta < 0) || (isAtBottom && delta > 0);

export const handleWheel = (element: HTMLElement, e: WheelEvent): void => {
  e.stopPropagation();
  const { isAtTop, isAtBottom } = isScrollAtBoundary(element.scrollTop, element.clientHeight, element.scrollHeight);

  if (shouldPreventScroll(isAtTop, isAtBottom, e.deltaY)) {
    e.preventDefault();
  }
};

export const handleTouch = (element: HTMLElement, e: TouchEvent): void => {
  e.stopPropagation();
  const { isAtTop, isAtBottom } = isScrollAtBoundary(element.scrollTop, element.clientHeight, element.scrollHeight);
  const touch = e.touches[0];

  if (touch && shouldPreventScroll(isAtTop, isAtBottom, touch.clientY)) {
    e.preventDefault();
  }
};
